import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$0c65 from '/src/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as imagekitRuntime$a1fc from '/src/node_modules/@nuxt/image/dist/runtime/providers/imagekit.js'
import * as ipxRuntime$abfe from '/src/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 599,
    "md": 959,
    "lg": 1263,
    "xl": 1903,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "img.caravanmarkt24.de",
    "img.staging.caravanmarkt24.de"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$0c65, defaults: {} },
  ['imagekit']: { provider: imagekitRuntime$a1fc, defaults: {"baseURL":"https://images.caravanmarkt24.de"} },
  ['ipx']: { provider: ipxRuntime$abfe, defaults: {} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
